import { Component } from '@angular/core';

@Component({
    selector: 'wim-investor-documents',
    templateUrl: 'investor-documents.component.pug',
})
export class InvestorDocumentsComponent {}
